import { ProcessImplantDataFileResponse } from "@veris-health/user-ms/lib/v1/api";
import { implantApiV1 } from "../../../api";

export const uploadImplantData = async (file: File): Promise<ProcessImplantDataFileResponse> => {
  const response = await implantApiV1.uploadImplantData(file);
  return response.data;
};
